import "../../../chunk-PKUHTIDK.js";
import isNull from "../base/isNull";
const property = (key, defs) => (object) => isNull(object) ? defs : object[key];
var property_default = property;
export {
  property_default as default
};
